"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var DashboardTableauAffaires_vue_1 = __importDefault(require("./DashboardTableauAffaires.vue"));
exports.default = vue_1.default.extend({
    components: { DashboardTableauAffaires: DashboardTableauAffaires_vue_1.default },
    data: function () {
        return {
            data: this.$root.$data,
            showAffairesTableau: false,
            groupeToShow: null
        };
    },
    methods: {
        loadAffairesTaches: function (indexPhase, indexGrp) {
            this.showAffairesTableau = true;
            this.groupeToShow = this.data.phaseGroupes[indexPhase].groupes[indexGrp];
        },
        retour: function () {
            this.showAffairesTableau = false;
            this.groupeToShow = null;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Dashboard/Components/Dashboard.vue
// module id = 176
// module chunks = 0